import {
  EAnalyticsLoggerActions,
  EAnalyticsLoggerEventNames,
  EAnalyticsLoggerEvents,
  EAnalyticsLoggerItemType,
} from '../types';
import { caseFactory } from '../utils';

export const confirmParticipation = caseFactory({
  name: EAnalyticsLoggerEventNames.ParticipateTender,
})
  .event(EAnalyticsLoggerEvents.ParticipateTender)
  .action(EAnalyticsLoggerActions.ClickButton)
  .itemType(EAnalyticsLoggerItemType.Tender);
